module.exports = __webpack_public_path__ + "img/phone.e3244472.png";